module.exports = __webpack_public_path__ + "0066d299905f18023ebf07c495f1c7db.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-58.png
// module id = 134
// module chunks = 0